import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/shared/ErrorBoundary';

// Import fonts
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

// UI v2 fonts: Geist (UI), Instrument Serif (hero numerals), JetBrains Mono (money)
import '@fontsource/geist/400.css';
import '@fontsource/geist/500.css';
import '@fontsource/geist/600.css';
import '@fontsource/instrument-serif/400.css';
import '@fontsource/jetbrains-mono/400.css';

import './index.css';
// Imported here rather than via `@import` in index.css on purpose: CSS requires
// @import to precede all rules, which would place the mobile layer BEFORE
// index.css's own legacy-alias block and lose every equal-specificity tie to it.
// Loading it last makes the mobile layer authoritative at <=767px.
import './styles/responsive.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
